<script setup>
import { computed, onMounted, ref } from 'vue'
import { consent, loadConsent, saveConsent } from '@/lib/consent'

// Aparece una sola vez: apenas hay respuesta se guarda, y en las visitas
// siguientes ya no hay nada que preguntar.
//
// La decisión se lee en onMounted y no antes porque localStorage no existe
// hasta que hay navegador. Hasta entonces el aviso no se dibuja, que es lo que
// se quiere: quien ya respondió no debería verlo parpadear.
const leido = ref(false)
const visible = computed(() => leido.value && consent.value === null)

onMounted(() => {
  loadConsent()
  leido.value = true
})

function decide (value) {
  saveConsent(value)
}
</script>

<template>
  <Transition
    enter-active-class="transition duration-500 ease-soft"
    enter-from-class="opacity-0 translate-y-6"
    leave-active-class="transition duration-300 ease-soft"
    leave-to-class="opacity-0 translate-y-6"
  >
    <section
      v-if="visible"
      aria-label="Aviso de cookies"
      class="fixed inset-x-0 bottom-0 z-50 border-t border-linen/15 bg-night/95 text-linen backdrop-blur"
    >
      <div class="mx-auto flex max-w-5xl flex-col gap-4 px-6 py-5 sm:flex-row sm:items-center sm:justify-between sm:gap-8">
        <p class="text-sm leading-relaxed text-linen/80">
          Usamos cookies de medición para saber qué anuncio trajo cada
          cotización. Si las rechazas el sitio funciona igual y tu cotización
          llega lo mismo.
          <a
            href="/privacidad"
            class="font-semibold text-linen underline decoration-linen/30 underline-offset-4 transition-colors hover:text-glow hover:decoration-glow"
          >Política de privacidad</a>.
        </p>

        <!-- Los dos botones pesan lo mismo de ancho y se distinguen por color,
             no por tamaño: un "Rechazar" más chico que el "Aceptar" es una
             respuesta empujada, y entonces no es una respuesta. -->
        <div class="flex shrink-0 gap-3">
          <button
            type="button"
            class="rounded-full px-5 py-2.5 text-sm font-semibold text-linen/80 ring-1 ring-linen/25 transition-colors hover:text-linen hover:ring-linen/50"
            @click="decide('denied')"
          >
            Rechazar
          </button>
          <button
            type="button"
            class="rounded-full bg-glow px-5 py-2.5 text-sm font-semibold text-night transition-colors hover:bg-[#f4a62a]"
            @click="decide('granted')"
          >
            Aceptar
          </button>
        </div>
      </div>
    </section>
  </Transition>
</template>
